import { ModalBloc } from './ModalBloc';
import { SimpleModalStateData } from './SimpleModal';

export interface SimpleModalBlocData extends Omit<SimpleModalStateData, 'isOpen'> {}

export class SimpleModalBloc extends ModalBloc<SimpleModalBlocData, SimpleModalStateData> {}
